/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FollowedCompanyResponse } from '../../models/followed-company-response';

export interface GetFollowedCompanies$Params {
}

export function getFollowedCompanies(http: HttpClient, rootUrl: string, params?: GetFollowedCompanies$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FollowedCompanyResponse>>> {
  const rb = new RequestBuilder(rootUrl, getFollowedCompanies.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<FollowedCompanyResponse>>;
    })
  );
}

getFollowedCompanies.PATH = '/api/company/followed';
